import Search from './sd-search'
import Table from './DynamicTable/DyTable'
import TemplateDialogWraper from './Dialog/TemplateDialogWraper'
import sdSelect from './SdSelect'
import SdInputNumber from './SdInputNumber'
import SdInputNumberRange from './SdInputNumberRange'
import Form from './DynamicForm/DyForm.vue'
import DyQuery from './DynamicQueryPage/DyQueryPage.vue'
import ItemWraper from './DynamicForm/DyFormitemWraper'

const components = [
  Search,
  Table,
  Form,
  DyQuery,
  TemplateDialogWraper,
  sdSelect,
  SdInputNumber,
  SdInputNumberRange,
  ItemWraper
]

export default components



// WEBPACK FOOTER //
// ./src/components/index.js